/**
 * Created by v-grfore on 04/09/2016.
 */

export const STRING_TO_MEASURE: string = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

export class SVGHelpers {

  /**
   * Calculates the dimensions of an SVG text based on its font attributes or CSS class.
   * Done by adding the text to the DOM, measuring, deleting from the DOM and returning attributes.
   * Needs to be used with caution for performance reasons, better to measure once an "abcdefghij...xyz...0123...9" string and simply calculate an approximate string length based on that, than calling this function every time.
   * @param textContent
   * @param cssClassName
   * @param fontFamily
   * @param fontSize
   * @param fontWeight
   * @returns {SVGRect}
   */
  public static getSvgTextBoxDimensions(textContent: string, cssClassName?: string, fontFamily?: string, fontSize?: string|number, fontWeight?: string): SVGRect {

    let svgElement: SVGSVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    document.body.appendChild(svgElement);

    let svgTextElement: SVGTextElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');

    if (cssClassName) {
      svgTextElement.setAttributeNS(null, 'class', cssClassName);
    } else {
      if (fontFamily) { svgTextElement.setAttributeNS(null, 'font-family', fontFamily); }
      if (fontSize) { svgTextElement.setAttributeNS(null, 'font-size', fontSize.toString()); }
      if (fontWeight) { svgTextElement.setAttributeNS(null, 'font-weight', fontWeight); }
    }
    svgTextElement.setAttributeNS(null, 'visibility', 'hidden');
    svgTextElement.textContent = textContent;

    svgElement.appendChild(svgTextElement);

    let box: SVGRect = {
      x: svgTextElement.getBBox().x,
      y: svgTextElement.getBBox().y,
      width: svgTextElement.getBBox().width,
      height: svgTextElement.getBBox().height
    };

    // clean (delete) SVGs created:
    svgElement.removeChild(svgTextElement);
    document.body.removeChild(svgElement);

    return box;
  }

  public static stringToMeasureLength(): number {
    return STRING_TO_MEASURE.length;
  }

  public static getTextWidth(text: string, stringToMeasureWidth: number): number {
    return Math.ceil( stringToMeasureWidth / STRING_TO_MEASURE.length * text.length );
  }

  public formatCurrency(cents: number, currencySymbol: string): string {
    return currencySymbol + `${(cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }
}


// WEBPACK FOOTER //
// ./src/SvgHelpers.ts